import { _callBackend } from '@/_api/api';
import type { APIRequest, APIResponsePromise } from '@/_types/api';
import type { Firm } from '@/_types/models/firm';

export const getCurrentFirm = async ({
  token,
}: APIRequest): APIResponsePromise<Firm> =>
  await _callBackend('/firms/current_user_firm', 'GET', null, token);

export const getAvailableFirms = async ({
  token,
}: APIRequest): APIResponsePromise<Array<Firm>> =>
  await _callBackend('/firms/available', 'GET', null, token);
